<template>
    <form class="form-fields ui-front" action="/purchase-shapefiles/search">
        <div class="autocomplete-search-field">
            <autocomplete name="query"
                          placeholder="Search by County Name."
                          data-source="/purchase-shapefiles/autocomplete"
                          sub-value="label"
                          :input-string.sync="searchString"
                          category-sub-value="value.kind"
                          v-on:selected="onSelect"
            ></autocomplete>
            <input type="submit" value="Submit" />
        </div>
    </form>
</template>

<script>
    export default {
        name: "CountySearch",

        data() {
            return {
                searchString: ''
            }
        },

        methods: {
            onSelect: function (suggestion) {
                if (suggestion === null)
                    return;
                if (typeof suggestion.value.url === "undefined")
                    return;
                window.location.href = suggestion.value.url;
            }
        }
    }
</script>

<style scoped>

</style>
